import React from "react";
import { IconName } from "react-icons/ai";
import { MdOutlineWatchLater } from "react-icons/md";
import { FaRegComment } from "react-icons/fa";
import { IoArrowForwardOutline } from "react-icons/io5";
import { Link } from "react-router-dom";



const Itemservices = (props) => {
    return (
        <>
            <div class="row-item">
                <div class="row-item-inner">
                    <div class="row-photos">
                        <img src={props.path} />
                    </div>
                    <div class="row-txt">
                        <div class="row-txt-inner">
                            <span>{props.titel}</span>
                            <h5>{props.t2}</h5>
                            <div class="icon" fontsize="20px">
                             <Link to='#'><IoArrowForwardOutline /></Link> 
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
const Testimonials = (props) => {
    return (
        <>
            <div class="review-itembox">
                <span class="quot"><img src={props.quot} /></span>
                <p>{props.text}
                </p>
                <div class="review-info">
                    <div class="author-img">
                        <img src={props.reviewphoto} />
                    </div>
                    <div class="cont">
                        <h6>{props.name}</h6>
                        <span>{props.work}</span>
                    </div>
                </div>
            </div>
        </>
    );
}
const Pricingblock = (props) => {
    return (
        <>
            <div class="pricing-itm">
                <div class="pricing-itm-inner">
                    <div class="pricing-img">
                        <img src={props.photo} />
                    </div>
                    <div class="text-pricing">
                        <h2>{props.titel}</h2>
                        <span>{props.dollar}</span>
                        <h3>{props.price}</h3>
                        <ul>

                            <li>{props.time}</li>
                            <li> {props.editing}</li>
                            <li>{props.info}</li>
                            <li>{props.gallery}</li>

                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
}
const Letest = (props) => {
    return (

        <>
            <div class="row">
                <div class="row-inner">
                    <div class="row-itm1">
                        <span><MdOutlineWatchLater /></span>
                        <span>{props.text}</span>
                        <span><FaRegComment /></span>
                        <span>{props.comment}</span>
                    </div>
                    <div class="row-itm2">
                        <h2>{props.Shots}</h2>
                    </div>
                    <div class="row-itm3">
                        <p>{props.text2}</p>
                    </div>
                    <div class="row-itm4">
                        <span>{props.more}</span>
                    </div>
                </div>
            </div>
        </>
    );
}

export { Itemservices, Testimonials, Pricingblock, Letest };